// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"f36f7607","110":"0854b8f2","187":"f03e704d","348":"b9ce0015","357":"474836dc","376":"81201916","445":"6dcb4301","477":"b2ea2000","488":"7720832d","651":"eb8e945a","980":"ecfa4901","998":"69a21800"}[chunkId] + ".chunk.js";
};